import ConfirmDialog from '@/components/common/ConfirmDialog';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';
import { MAX_AGE, MIN_AGE, birthDateIssue, parseDateField, toBengaliDigits } from './udyogFormEngine';

/**
 * Shown when a birth date falls outside the programme's rules on the closing
 * date: not yet an adult, over 28, or not born yet. It is a warning, not a wall —
 * the applicant may have a reason, and the bank makes the actual decision — so
 * it says what is wrong and lets them carry on, the way the voter forms do.
 *
 * @param {{ open: boolean, birthDate: string, confirmLabel?: string,
 *   onCancel: () => void, onConfirm: () => void }} props
 */
export default function UdyogAgeNoticeDialog({ open, birthDate, confirmLabel, onCancel, onConfirm }) {
    const { t, currentLanguage } = useTranslation();
    const issue = birthDateIssue(parseDateField(birthDate));
    if (!issue) return null;

    const number = (value) => (currentLanguage === 'bn' ? toBengaliDigits(value) : String(value));
    const values = {
        age: number(issue.age),
        min: number(MIN_AGE),
        max: number(MAX_AGE),
        date: t('udyogForm.closingDate'),
    };

    return (
        <ConfirmDialog
            open={open}
            onClose={onCancel}
            onConfirm={onConfirm}
            variant="primary"
            title={t(`udyogForm.ageNotice.${issue.kind}.title`, values)}
            description={t(`udyogForm.ageNotice.${issue.kind}.description`, values)}
            cancelLabel={t('underageNotice.cancel')}
            confirmLabel={confirmLabel || t('underageNotice.confirm')}
        >
            <ul className="w-full space-y-1.5 rounded-xl bg-orange-50/70 px-4 py-3 text-left dark:bg-orange-900/15">
                <li className="text-[12.5px] text-zinc-700 dark:text-zinc-200">
                    • {t('udyogForm.ageNotice.pointBank')}
                </li>
                <li className="text-[12.5px] font-semibold text-orange-600 dark:text-orange-300">
                    • {t('udyogForm.ageNotice.pointDate', values)}
                </li>
            </ul>
        </ConfirmDialog>
    );
}
